/* ═══════════════════════════════════════
   NOOON - Search Overlay
   ═══════════════════════════════════════ */

(function () {
  var overlay, input, resultsEl, trendingHTML;
  var searchTimeout = null;
  var searchSeq = 0;
  /* Localized strings, read from data attributes on the results container
     (set in sections/header.liquid from locale keys). English fallbacks. */
  var txtSearching = 'Searching...';
  var txtNoResults = 'No results';
  var txtResultsFor = 'Results for "%q%"';

  function open() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (input) input.value = '';
    searchSeq++; /* invalidate any in-flight response */
    if (resultsEl) {
      resultsEl.classList.remove('is-loading');
      if (trendingHTML) resultsEl.innerHTML = trendingHTML;
    }
  }

  // Escape dynamic values before they reach innerHTML (text + attribute contexts).
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Predictive search API returns price in dollars (not cents)
  function formatMoney(dollars) {
    var n = parseFloat(dollars);
    if (isNaN(n)) return '';
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function renderProducts(products, label) {
    if (!resultsEl) return;
    if (!products || !products.length) {
      resultsEl.innerHTML = '<p class="search-overlay__label">' + esc(txtNoResults.toUpperCase()) + '</p>';
      return;
    }
    resultsEl.innerHTML =
      '<p class="search-overlay__label">' + esc(label) + '</p>' +
      '<div class="search-overlay__products">' +
      products.slice(0, 6).map(function (p) {
        var img = p.featured_image ? '<img src="' + esc(p.featured_image.url + '&width=400') + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '';
        var price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + esc(p.url) + '" class="search-overlay__product">' +
          '<div class="search-overlay__product-img">' + img + '</div>' +
          '<span class="search-overlay__product-name">' + esc((p.title || '').toUpperCase()) + '</span>' +
          '<span class="search-overlay__product-price">' + price + '</span>' +
          '</a>';
      }).join('') +
      '</div>';
  }

  function doSearch(q) {
    var mySeq = ++searchSeq; /* ignore responses from superseded queries */
    if (resultsEl) {
      resultsEl.classList.add('is-loading');
      /* First query after trending: show an explicit searching label
         instead of dimming unrelated trending content. Subsequent queries
         keep the previous results dimmed until the fresh set renders. */
      if (trendingHTML && resultsEl.innerHTML === trendingHTML) {
        resultsEl.innerHTML = '<p class="search-overlay__label">' + esc(txtSearching.toUpperCase()) + '</p>';
      }
    }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (mySeq !== searchSeq) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var label = txtResultsFor.indexOf('%q%') !== -1
          ? txtResultsFor.replace('%q%', q)
          : txtResultsFor + ' "' + q + '"';
        renderProducts(products, label.toUpperCase());
        if (resultsEl) resultsEl.classList.remove('is-loading');
      })
      .catch(function () {
        if (mySeq === searchSeq && resultsEl) resultsEl.classList.remove('is-loading');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    overlay  = document.querySelector('[data-search-overlay]');
    input    = document.querySelector('[data-search-input]');
    resultsEl = document.querySelector('[data-search-results]');

    if (!overlay) return;

    // Capture initial trending HTML for resetting later
    trendingHTML = resultsEl ? resultsEl.innerHTML : '';

    if (resultsEl) {
      txtSearching = resultsEl.dataset.textSearching || txtSearching;
      txtNoResults = resultsEl.dataset.textNoResults || txtNoResults;
      txtResultsFor = resultsEl.dataset.textResultsFor || txtResultsFor;
    }

    // Open buttons (desktop + mobile)
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });

    // Close
    var closeBtn = overlay.querySelector('[data-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var backdrop = overlay.querySelector('[data-search-backdrop]');
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // Live search
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(searchTimeout);
        if (q.length < 2) {
          searchSeq++; /* invalidate any in-flight response */
          if (resultsEl) {
            resultsEl.classList.remove('is-loading');
            if (trendingHTML) resultsEl.innerHTML = trendingHTML;
          }
          return;
        }
        searchTimeout = setTimeout(function () { doSearch(q); }, 300);
      });
    }
  });
})();
